/* eslint-disable @typescript-eslint/comma-dangle */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Tab,
  Tabs,
  Tooltip,
} from '@mui/material';
import { a11yProps, TabPanel } from './TabPanel';
import CircleFill from '@mui/icons-material/Circle';
import '../../pages/Sensors/sensors.scss';

interface Props {
  currentSensorCheck: any;
  setCurrentSensorCheck: Function;
}

const CheckCurrentSensorModal = ({
  currentSensorCheck,
  setCurrentSensorCheck,
}: Props) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(0);
  const handleChange = (e: any, newValue: number) => {
    setValue(newValue);
  };

  /**
   * this function check the simStatus and return the correct value of svg color
   * @returns
   */
  const handleColorSVGSimStatus = () => {
    if (currentSensorCheck?.simStatus === null) {
      return 'disabled';
    } else if (currentSensorCheck?.simStatus === 'active') {
      return 'success';
    } else {
      return 'error';
    }
  };
  return (
    <Dialog
      className="dialog"
      open={!!currentSensorCheck}
      fullWidth
      onClose={() => setCurrentSensorCheck(undefined)}
    >
      <DialogTitle>
        <h3>{t('SENSOR_CHECK')}</h3>
      </DialogTitle>
      <DialogContent style={{ width: 600 }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label={t('INFO')} {...a11yProps(0)} />
          <Tab label={t('RAW_DIAGNOSTIC')} {...a11yProps(1)} />
        </Tabs>

        <TabPanel value={value} index={0}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <table>
                <tbody>
                  <tr>
                    <th>{t('BANNED')}</th>
                    <td>
                      <Tooltip
                        placement="top"
                        title={
                          currentSensorCheck &&
                          t(currentSensorCheck?.banned ? 'YES' : 'NO')
                        }
                      >
                        <CircleFill
                          fontSize="small"
                          color={
                            currentSensorCheck?.banned ? 'error' : 'success'
                          }
                        />
                      </Tooltip>
                    </td>
                  </tr>
                  <tr>
                    <th>{t('Kyc')}</th>
                    <td>
                      <Tooltip
                        placement="top"
                        title={
                          currentSensorCheck &&
                          t(currentSensorCheck?.kyc ? 'YES' : 'NO')
                        }
                      >
                        <CircleFill
                          fontSize="small"
                          color={currentSensorCheck?.kyc ? 'success' : 'error'}
                        />
                      </Tooltip>
                    </td>
                  </tr>
                  <tr>
                    <th>{t('VALID_WALLET')}</th>
                    <td>
                      <Tooltip
                        placement="top"
                        title={
                          currentSensorCheck &&
                          t(currentSensorCheck?.validWallet ? 'YES' : 'NO')
                        }
                      >
                        <CircleFill
                          fontSize="small"
                          color={
                            currentSensorCheck?.validWallet
                              ? 'success'
                              : 'error'
                          }
                        />
                      </Tooltip>
                    </td>
                  </tr>
                  <tr>
                    <th>{t('HAS_PLANET')}</th>
                    <td>
                      <Tooltip
                        placement="top"
                        title={
                          currentSensorCheck &&
                          t(currentSensorCheck?.hasPlanets ? 'YES' : 'NO')
                        }
                        id={''}
                      >
                        <CircleFill
                          fontSize="small"
                          color={
                            currentSensorCheck?.hasPlanets ? 'success' : 'error'
                          }
                        />
                      </Tooltip>
                    </td>
                  </tr>
                  <tr>
                    <th>{t('NFT')}</th>
                    <td>
                      {(currentSensorCheck?.nfts?.sensor?.statusNft ===
                        'NotInitialized' ||
                        currentSensorCheck?.nfts === undefined ||
                        currentSensorCheck?.nfts === null ||
                        currentSensorCheck?.nfts?.sensor === undefined ||
                        currentSensorCheck?.nfts?.sensor === null) && (
                        <Tooltip
                          placement="top"
                          title={currentSensorCheck && t('NotInitialized')}
                          id={''}
                        >
                          <CircleFill fontSize="small" color="error" />
                        </Tooltip>
                      )}
                      {currentSensorCheck?.nfts?.sensor?.statusNft === 'Ok' && (
                        <Tooltip
                          placement="top"
                          title={currentSensorCheck && t('Ok')}
                        >
                          <CircleFill fontSize="small" color="success" />
                        </Tooltip>
                      )}
                      {currentSensorCheck?.nfts?.sensor?.statusNft ===
                        'Amount 0' && (
                        <Tooltip
                          placement="top"
                          title={currentSensorCheck && t('Amount 0')}
                        >
                          <CircleFill fontSize="small" color="warning" />
                        </Tooltip>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>{t('LOCATION')}</th>
                    <td>
                      <Tooltip
                        placement="top"
                        title={
                          currentSensorCheck &&
                          t(currentSensorCheck?.position ? 'YES' : 'NO')
                        }
                        id={''}
                      >
                        <CircleFill
                          fontSize="small"
                          color={
                            currentSensorCheck?.position ? 'success' : 'error'
                          }
                        />
                      </Tooltip>
                    </td>
                  </tr>
                  <tr>
                    <th>{t('Stato Sim')}</th>
                    <td>
                      <Tooltip
                        placement="top"
                        title={
                          currentSensorCheck && t(currentSensorCheck?.simStatus)
                        }
                      >
                        <CircleFill
                          fontSize="small"
                          color={handleColorSVGSimStatus()}
                        />
                      </Tooltip>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Grid>

            <Grid item xs={6}>
              <table>
                <tbody>
                  <tr>
                    <th style={{ paddingLeft: '1.7em' }}>{t('LICENSES')}</th>
                  </tr>
                  <tr>
                    <td>
                      <table>
                        <thead>
                          <tr>
                            <th>{t('NFT')}</th>
                            <th>{t('NFT_STATUS')}</th>
                            <th>{t('LICENSE_STATUS')}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(currentSensorCheck?.nfts?.licenses || []).map(
                            (license: any, index: number) => (
                              <tr key={`license-${index}`}>
                                <td>{license?.nft}</td>
                                <td>
                                  {license?.statusNft == 'NotInitialized' && (
                                    <Tooltip
                                      placement="top"
                                      title={
                                        currentSensorCheck &&
                                        t('NotInitialized')
                                      }
                                      id={''}
                                    >
                                      <CircleFill
                                        fontSize="small"
                                        color="error"
                                      />
                                    </Tooltip>
                                  )}
                                  {license?.statusNft == 'Ok' && (
                                    <Tooltip
                                      placement="top"
                                      title={currentSensorCheck && t('Ok')}
                                    >
                                      <CircleFill
                                        fontSize="small"
                                        color="success"
                                      />
                                    </Tooltip>
                                  )}
                                  {license?.statusNft == 'Amount 0' && (
                                    <Tooltip
                                      placement="top"
                                      title={
                                        currentSensorCheck && t('Amount 0')
                                      }
                                    >
                                      <CircleFill
                                        fontSize="small"
                                        color="warning"
                                      />
                                    </Tooltip>
                                  )}
                                </td>
                                <td>
                                  {license?.statusLicense == 'Not Active' && (
                                    <Tooltip
                                      placement="top"
                                      title={
                                        currentSensorCheck && t('NotActive')
                                      }
                                    >
                                      <CircleFill
                                        fontSize="small"
                                        color="warning"
                                      />
                                    </Tooltip>
                                  )}
                                  {license?.statusLicense == 'Active' && (
                                    <Tooltip
                                      placement="top"
                                      title={currentSensorCheck && t('Active')}
                                    >
                                      <CircleFill
                                        fontSize="small"
                                        color="success"
                                      />
                                    </Tooltip>
                                  )}
                                  {license?.statusLicense == 'Expired' && (
                                    <Tooltip
                                      placement="top"
                                      title={currentSensorCheck && t('Expired')}
                                    >
                                      <CircleFill
                                        fontSize="small"
                                        color="error"
                                      />
                                    </Tooltip>
                                  )}
                                </td>
                              </tr>
                            )
                          )}
                          {!currentSensorCheck?.nfts?.licenses?.length && (
                            <tr>
                              <td colSpan={3} style={{ textAlign: 'center' }}>
                                {t('NO_LICENSES')}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <pre
            className="jsonFile"
            style={{
              background: 'whitesmoke',
              borderRadius: '0.5em',
              maxWidth: 500,
              overflowX: 'scroll',
            }}
          >
            {JSON.stringify(currentSensorCheck, null, 1)}
          </pre>
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
};

export default CheckCurrentSensorModal;
